import { render, staticRenderFns } from "./tokenError.vue?vue&type=template&id=11bc6d4a&"
import script from "./tokenError.vue?vue&type=script&lang=js&"
export * from "./tokenError.vue?vue&type=script&lang=js&"
import style0 from "./tokenError.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports